export default __webpack_public_path__ + "static/media/sitrobo.5bf4ae82.svg";